function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.183,
    height: 21.246,
    viewBox: "0 0 16.183 21.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5100",
    d: "M62.867 21.246h12.449a1.869 1.869 0 0 0 1.867-1.867V6.224h-4.357a1.869 1.869 0 0 1-1.867-1.867V0h-8.092A1.869 1.869 0 0 0 61 1.867v17.512a1.869 1.869 0 0 0 1.867 1.867zm2.49-12.49h7.469a.622.622 0 1 1 0 1.245h-7.469a.622.622 0 1 1 0-1.245zm0 2.49h7.469a.622.622 0 1 1 0 1.245h-7.469a.622.622 0 1 1 0-1.245zm0 2.49h7.469a.622.622 0 1 1 0 1.245h-7.469a.622.622 0 1 1 0-1.245zm0 2.49h4.98a.622.622 0 0 1 0 1.245h-4.98a.622.622 0 1 1 0-1.245z",
    style: {
      fill: "#aeaeae"
    },
    transform: "translate(-61)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5101",
    d: "M331.622 13.4h3.992L331 8.789v3.992a.623.623 0 0 0 .622.619z",
    transform: "translate(-319.796 -8.424)",
    style: {
      fill: "#aeaeae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.e6528ee77fdf9268b7ad14e9c798c7c9.svg";
export { ForwardRef as ReactComponent };